<template>
  <div>
    <div class="border-t border-dashed border-gray-200 my-3"></div>
    <div class="flex items-center gap-1.5">
      <DsSwitch
        :model-value="modelValue"
        @update:model-value="emit('update:modelValue', $event)"
        :data-testid="dataTestid"
        label="🔗 Registro de Permanência"
        size="small"
      />
      <v-tooltip :text="PERMANENCE_TOOLTIP_TEXT">
        <template v-slot:activator="{ props: tooltipProps }">
          <span
            v-bind="tooltipProps"
            class="inline-flex items-center justify-center w-[14px] h-[14px] rounded-full border border-gray-400 text-[9px] text-gray-500 cursor-help"
            >?</span
          >
        </template>
      </v-tooltip>
    </div>
    <p class="text-[10px] text-gray-500 leading-snug mt-1">
      {{ PERMANENCE_TOOLTIP_TEXT }}
    </p>
  </div>
</template>

<script setup lang="ts">
import DsSwitch from '@/components/designSystem/Switch/index.vue'

defineProps<{
  modelValue: boolean
  dataTestid: string
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

const PERMANENCE_TOOLTIP_TEXT =
  'Auto check-out/check-in na transição de plantões sequenciais da mesma escala, quando o médico permanece sem registrar saída.'
</script>
